import React from 'react'

import Headline from './atoms/headline'

const About = () => {
    return (
        <div id='about' className='section'>
            <Headline
                title={'About'}
                subTitle={'スタジオについて'}
            />
            {/* 狭い画面で語の途中で折り返さないよう、意味の切れ目で区切る */}
            <p className='text'>
                <span>高坂駅から徒歩3分</span>
                <span>大型鏡・リノリウム完備のスタジオ</span><br />
                <span>バレエ、ダンス、フィットネス、</span>
                <span>打ち合わせなど</span><br />
                <span>様々な用途でご利用いただけます。</span>
            </p>
        </div>
    )
}

export default About
